// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"341ce564","476":"70e74755","763":"683c2954"}[chunkId] + ".chunk.js";
};